import { Injectable } from '@angular/core';
import { LMContextService } from '@services/lm-context.service';
import { LMGlobalState } from '@states/models/lm-global-state.model';
import { LMStatePersistenceService } from '@services/lm-state-persistence.service';

class LMGlobalStateKeyParams {
  actorId?: string;

  getKey(): string {
    return this.actorId + '_banner';
  }
}

@Injectable()
export class LMGlobalStateService {
  private stateKey: string;

  constructor(
    private lmContextService: LMContextService,
    private lmStatePersistenceService: LMStatePersistenceService
  ) {}

  private get key(): string {
    if (!this.stateKey) {
      const stateKeyParams = new LMGlobalStateKeyParams();
      stateKeyParams.actorId = this.lmContextService.getActorId();
      this.stateKey = stateKeyParams.getKey();
    }
    return this.stateKey;
  }

  public getGlobalState(): LMGlobalState {
    return this.lmStatePersistenceService.getState(this.key);
  }

  public saveGlobalState(globalStateItem: LMGlobalState): void {
    this.lmStatePersistenceService.persistState(this.key, globalStateItem);
  }

  public deleteGlobalState(): void {
    this.lmStatePersistenceService.removeState(this.key);
  }
}
